import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/Rice_bag.png";

const Rice = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Rice"
            image={[raw]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Rice;